import { isClientSide } from "@helper/utils";
import { useEffect, useRef, useState } from "react";

export default function useVisibleArticle(triggerState: string) {
  const [visibleArticleId, setVisibleArticleId] = useState<
    string | undefined
  >();
  const visibleEntriesRef = useRef<Map<Element, number>>(new Map());
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (!isClientSide) return;

    const findMostVisibleArticle = () => {
      let maxVisibleId = "";
      let maxVisibility = 0;

      visibleEntriesRef.current.forEach((visibility, element) => {
        if (visibility > maxVisibility) {
          maxVisibility = visibility;
          maxVisibleId = element.id;
        }
      });

      setVisibleArticleId(maxVisibleId);
    };

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleEntriesRef.current.set(
              entry.target,
              entry.intersectionRatio,
            );
          } else {
            visibleEntriesRef.current.delete(entry.target);
          }
        });
        findMostVisibleArticle();
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0.1, 0.25, 0.5, 0.75, 1.0], // Explicitly float for clarity
      },
    );

    const articles = document.querySelectorAll(".article-card");
    articles.forEach((article) => observerRef.current?.observe(article));

    return () => {
      observerRef.current?.disconnect();
    };
  }, [triggerState]); // Re-run effect only when triggerState changes

  return visibleArticleId;
}
